import {useTableInstance} from '../../hooks/tanstack-table/providers/table-provider'
import {useBulkAddNotifications} from '../../state-providers/bulk-add-notifications/bulk-add-notifications-state-provider'
import {PLACEHOLDER_ROW_COUNT, PlaceholderRow} from './table-pagination'

/**
 * Renders skeleton rows during bulk add operations when there are no items in the table view.
 * Only visible when a bulk add is in progress and the items list is empty.
 */
export function BulkAddTableSkeleton() {
  const {shouldShowSkeleton} = useBulkAddNotifications()
  const {getVisibleLeafColumns} = useTableInstance()
  const visibleColumns = getVisibleLeafColumns()

  if (!shouldShowSkeleton) {
    return null
  }

  return (
    <>
      {[...Array(PLACEHOLDER_ROW_COUNT).keys()].map(key => (
        <PlaceholderRow key={key} columns={visibleColumns} />
      ))}
    </>
  )
}
